export class StorageService {
  getPrefix = (key) => {
    const SITE_NAME = window.location.pathname.split('/')[2];
    this.funcName = 'getPrefix'; // added this to suppress eslint warning
    return `${SITE_NAME}.${key}`;
  };

  getSession = (key) => {
    return sessionStorage.getItem(this.getPrefix(key));
  };

  setSession = (key, value) => {
    return sessionStorage.setItem(this.getPrefix(key), value);
  };

  removeSession = (key) => {
    sessionStorage.removeItem(this.getPrefix(key));
  };

  setSessionDocUpload = (key, value, sitename) => {
    return sessionStorage.setItem(`${sitename}.${key}`, value);
  };

  removeSessionDocUpload = (key, sitename) => {
    return sessionStorage.removeItem(`${sitename}.${key}`);
  };
}
